var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('q-popup-edit',_vm._g(_vm._b({ref:"popupEdit",staticClass:"cmp-domain-popup",attrs:{"content-class":"domain-popup","anchor":"top middle","self":"bottom middle","cover":false}},'q-popup-edit',_vm.$attrs,false),_vm.$listeners),[_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }